document.addEventListener('DOMContentLoaded', function() {
  setupSearchForm();
});

function setupSearchForm() {
  const searchForms = document.querySelectorAll('.persistent-search-form');
  
  searchForms.forEach(form => {
    const resetButton = form.querySelector('button[type="reset"]');
    const searchInput = form.querySelector('input[type="search"]');
    const predictiveSearch = form.querySelector('predictive-search');
    
    if (resetButton && searchInput) {
      // Handle reset button click
      resetButton.addEventListener('click', function(e) {
        e.preventDefault(); // Prevent default reset behavior
        
        // Clear the input
        searchInput.value = '';
        
        // Focus back on the input
        searchInput.focus();
        
        // Dispatch input event to trigger predictive search update
        searchInput.dispatchEvent(new Event('input', { bubbles: true }));
        
        // Hide search results if we have access to predictive-search
        if (predictiveSearch) {
          // Reset any custom attributes
          predictiveSearch.setAttribute('data-results-open', 'false');
          
          // Remove the results-open class from parent
          const searchBar = document.querySelector('.persistent-search-bar');
          if (searchBar) {
            searchBar.classList.remove('results-open');
          }
        }
      });
      
      // Show/hide reset button based on input content
      searchInput.addEventListener('input', function() {
        resetButton.style.display = this.value.length > 0 ? 'flex' : 'none';
      });
      
      // Initial state - hide reset button if input is empty
      resetButton.style.display = searchInput.value.length > 0 ? 'block' : 'none';
    }
  });
}
